// extracted by mini-css-extract-plugin
module.exports = {"switch":"themeswitch-module--switch--2uH8p"};